import Mockup from '@propertypal/shared/src/resources/images/promotion-on-social-media/dev-socials-mockup.png';
import React from 'react';
import { ItalicText, MidHeading, Text } from '../typography';
import {
  Container,
  Wrapper,
  Section,
  SectionImageContainer,
  SectionImage,
  ContentSection,
  Cards,
  Card,
} from './SocialKeyStatistics.style';

const SocialKeyStatistics: React.FC = () => {
  return (
    <Container>
      <Wrapper>
        <Section>
          <ContentSection>
            <MidHeading mb={35} fontSize={22} fontWeight="normal">
              Key Statistics
            </MidHeading>
            <Text fontSize={18} mb={25} fontWeight="bold">
              Our social media channels over the last year have driven:
            </Text>
            <Cards>
              <Card>
                <b>267 million</b> impressions*
              </Card>
              <Card>
                <b>2.25 million</b> engagements
              </Card>
              <Card>
                <b>217,000</b> shares
              </Card>
              <Card>
                <b>7.26%</b> engagement rate
              </Card>
            </Cards>
            <ItalicText align="center" mt={40}>
              <b>Note:</b> Above 6% = very high engagement rate
            </ItalicText>
          </ContentSection>
          <SectionImageContainer>
            <SectionImage src={Mockup.src} alt="PropertyPal.com Social Media Key Statistics" />
          </SectionImageContainer>
        </Section>
        <Text align="center" fontSize={14} mt={80}>
          *Impressions are the number of times the advert is shown on the PropertyPal social media channels
        </Text>
      </Wrapper>
    </Container>
  );
};

export default SocialKeyStatistics;
